export default __webpack_public_path__ + "static/image153-8a3a0ae4a0a2bc4bfbe4313d626cc048.jpg";